import './assets/style/main.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import AgentApplication from '@components/pages/agent-application';
import ApplicationSuccess from '@components/pages/application-success';
import HowItWorks from '@components/pages/howitworks';
import LandingPage from '@components/pages/landing-page';
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router';

import Page404 from './components/pages/page404';
import { pageurl } from './constants/pageurl';

// Reached only from a party's single-use invitation link, so it stays out of
// the landing funnel's initial bundle.
const TrustedAgentRegister = lazy(async () => await import('./components/pages/trusted-agent-register'));

const App = () => (
	<Router basename={process.env.PUBLIC_URL}>
		<Suspense fallback={<></>}>
			<Routes>
				<Route
					path={pageurl.OVERVIEW}
					element={<LandingPage />}
				/>
				<Route
					path={pageurl.APPLICATIONSUCCESS}
					element={<ApplicationSuccess />}
				/>
				<Route
					path={pageurl.AGENTAPPLICATION}
					element={<AgentApplication />}
				/>
				<Route
					path={pageurl.INSTRUCTIONS}
					element={<HowItWorks />}
				/>
				<Route
					path={pageurl.TRUSTED_AGENT_REGISTER}
					element={<TrustedAgentRegister />}
				/>
				<Route
					path='*'
					element={<Page404 />}
				/>
			</Routes>
		</Suspense>
	</Router>
);

export default App;
